<template>
  <b-form-group label="Title">
    <b-input v-model="content.title" placeholder="e.g Say hello" />
  </b-form-group>
</template>

<script>
export default {
  name: 'PagesContactFormWidget',
  props: { value: { type: Object } },
  data() {
    return { content: this.value }
  },
}
</script>
